module.exports = "/assets/data/e6bf1d343635062af718f6e9e950aa3b-BT30.data.json";